import store from 'base/store'
import 'data-layer-helper/dist/data-layer-helper'
import Hub from 'base/hub'
import Event from 'base/event'
import SiteLocation from 'base/constants/site_location'
import { saveVisitor } from 'base/actions/asynchronous'

const WunderkindEvent = {
  IMPRESSION: 'wunderkind.impression',
  SUBMIT: 'wunderkind.submit',
  REJECTION: 'wunderkind.rejection',
}

const isSmsCampaign = campaign => /attentive|phone|sms|text/i.test(campaign)
const isExitCampaign = campaign => /disengagement/i.test(campaign)

// Campaign names come in a format like: “Email Capture | Entrance | All Devices | Variation B”.
// We’ll consider everything up to the final | as our experiment name, and the final bit as our
// treatment name.
const parseCampaign = campaign => {
  const experimentEnd = campaign.indexOf(' | Variation') || campaign.lastIndexOf('|')
  const treatmentStart = campaign.indexOf('Variation') - 1 || campaign.lastIndexOf('|') + 1

  const campaignName = campaign.slice(0, experimentEnd).trim()
  const variation = campaign.slice(treatmentStart + 1).trim()

  return {
    campaignName,
    variation,
    isSmsCampaign: isSmsCampaign(campaign),
    isExitCampaign: isExitCampaign(campaign),
  }
}

const handleWunderkindImpression = () => {
  const modalViewProperties = { site_location: SiteLocation.WUNDERKIND_MODAL }

  if (isSmsCampaign) {
    Hub.pub(Event.Attentive.MODAL_VIEW, modalViewProperties)
  } else {
    Hub.pub(Event.Login.MODAL_VIEW, modalViewProperties)
  }
}

const handleWunderkindSubmit = (campaign, email, gender, phone) => {
  const { campaignName, isSmsCampaign, isExitCampaign } = parseCampaign(campaign)

  if (isSmsCampaign) {
    if (phone) {
      store.dispatch(saveVisitor({ phone_number_attributes: { number: phone } }))
    }

    Hub.pub(Event.Attentive.SMS_ENTERED, {
      experiment: campaignName,
      site_location: SiteLocation.WUNDERKIND_MODAL,
    })
  } else {
    const emailEnteredProperties = {
      experiment: campaignName,
      email,
      site_location: SiteLocation.WUNDERKIND_MODAL,
    }

    if (gender) {
      store.dispatch(saveVisitor({ gender }))
    }

    Hub.pub(Event.Login.EMAIL_ENTERED, emailEnteredProperties)

    Hub.pub(Event.Wunderkind.EMAIL_ENTERED, {
      ...emailEnteredProperties,
      shouldAskForPassword: !isExitCampaign,
    })
  }
}

const handleWunderkindRejection = campaign => {
  const { campaignName, isSmsCampaign } = parseCampaign(campaign)

  const modalClosedProperties = {
    experiment: campaignName,
    site_location: SiteLocation.WUNDERKIND_MODAL,
  }

  if (isSmsCampaign) {
    Hub.pub(Event.Attentive.MODAL_CLOSED, modalClosedProperties)
  } else {
    Hub.pub(Event.Login.MODAL_CLOSED, modalClosedProperties)
  }
}

const wunderkind = () => {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  window.dataLayer ||= []

  new window.DataLayerHelper(window.dataLayer, (_model, message) => {
    if (message.event === WunderkindEvent.IMPRESSION) {
      handleWunderkindImpression(message.campaign)
    }

    if (message.event === WunderkindEvent.SUBMIT) {
      handleWunderkindSubmit(
        message.campaign,
        message.wunderkind_email,
        message.gender,
        message.phone,
      )
    }

    if (message.event === WunderkindEvent.REJECTION) {
      handleWunderkindRejection(message.campaign)
    }
  })
}

export default wunderkind
